import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-financial-status',
  templateUrl: './financial-status.component.html',
  styleUrls: ['./financial-status.component.scss'],
  standalone: false
})
export class FinancialStatusComponent implements OnChanges {
  @Input() examId: number | null = null;
  statuses = ['waiting', 'sent', 'paid'];
  labels = { waiting: 'Waiting', sent: 'Sent, awaiting payment', paid: 'Paid' };
  payerStatus = 'waiting';
  performerStatus = 'waiting';
  error = false;

  constructor(private http: HttpClient, public ls: LoginService) { }

  get allowed(): boolean {
    return !!this.ls.premissions && !!this.ls.premissions['FinancialReports'];
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.examId && this.examId && this.allowed) {
      await this.load();
    }
  }

  async load() {
    try {
      const status: any = await this.http.get(`/api/financial/status/${this.examId}`).toPromise();
      this.payerStatus = status.payerStatus;
      this.performerStatus = status.performerStatus;
      this.error = false;
    } catch (error) {
      this.error = true;
    }
  }

  async save(field: 'payerStatus' | 'performerStatus') {
    try {
      const result: any = await this.http
        .put('/api/financial/status', { ExamID: this.examId, [field]: this[field] })
        .toPromise();
      this.payerStatus = result.payerStatus;
      this.performerStatus = result.performerStatus;
      this.error = false;
    } catch (error) {
      this.error = true;
      await this.load();
    }
  }
}
